import { render } from "./VideoListmore.vue?vue&type=template&id=203a8b1e&scoped=true"
import script from "./VideoListmore.vue?vue&type=script&lang=js"
export * from "./VideoListmore.vue?vue&type=script&lang=js"

import "./VideoListmore.vue?vue&type=style&index=0&id=203a8b1e&scoped=true&lang=css"

import exportComponent from "D:\\wcb\\www\\clpga_htmlgit_master\\f_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-203a8b1e"]])

export default __exports__